import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { RounderUtil } from 'utils'

const PrecioListaFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, values, setValues }) => {
  return (
    <Form.Group>
      <Form.Label text='PRECIO LISTA' htmlFor='select-precioLista' xs={12} />
      <Col xs={12}>
        <Field name='precioLista'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-precioLista'
              onChange={e => {
                handleChange(e)
                if (e.target.value) {
                  const fieldValue = parseFloat(e.target.value)
                  values.precioLista = fieldValue
                  const discountAmount = (fieldValue * values.porcentajeDescuento) / 100
                  values.precioNeto = RounderUtil.round(fieldValue - discountAmount, 4)
                  setValues(values)
                } else {
                  values.precioLista = e.target.value
                  values.precioNeto = 0
                  setValues(values)
                }
              }}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PrecioListaFormGroup)
